module.exports = __webpack_public_path__ + "static/media/SiteStep1.9c9d332e.svg";